var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapRevenueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9365 8.83203H17.0648C11.9082 8.83203 8.83398 11.9062 8.83398 17.0629V28.9204C8.83398 34.0912 11.9082 37.1654 17.0648 37.1654H28.9223C34.079 37.1654 37.1532 34.0912 37.1532 28.9345V17.0629C37.1673 11.9062 34.0932 8.83203 28.9365 8.83203ZM16.8098 31.7112C16.8098 32.292 16.3282 32.7737 15.7473 32.7737C15.1665 32.7737 14.6848 32.292 14.6848 31.7112V28.7787C14.6848 28.1979 15.1665 27.7162 15.7473 27.7162C16.3282 27.7162 16.8098 28.1979 16.8098 28.7787V31.7112ZM24.0632 31.7112C24.0632 32.292 23.5815 32.7737 23.0007 32.7737C22.4198 32.7737 21.9382 32.292 21.9382 31.7112V25.832C21.9382 25.2512 22.4198 24.7695 23.0007 24.7695C23.5815 24.7695 24.0632 25.2512 24.0632 25.832V31.7112ZM31.3165 31.7112C31.3165 32.292 30.8348 32.7737 30.254 32.7737C29.6732 32.7737 29.1915 32.292 29.1915 31.7112V22.8995C29.1915 22.3187 29.6732 21.837 30.254 21.837C30.8348 21.837 31.3165 22.3187 31.3165 22.8995V31.7112ZM31.3165 18.4229C31.3165 19.0037 30.8348 19.4854 30.254 19.4854C29.6732 19.4854 29.1915 19.0037 29.1915 18.4229V17.0487C25.579 20.7604 21.0598 23.3812 16.0023 24.642C15.9173 24.6704 15.8323 24.6704 15.7473 24.6704C15.2657 24.6704 14.8407 24.3445 14.7132 23.8629C14.5715 23.2962 14.9115 22.7154 15.4923 22.5737C20.2665 21.3837 24.5165 18.8762 27.8882 15.3345H26.1173C25.5365 15.3345 25.0548 14.8529 25.0548 14.272C25.0548 13.6912 25.5365 13.2095 26.1173 13.2095H30.2681C30.3248 13.2095 30.3673 13.2379 30.424 13.2379C30.4948 13.252 30.5656 13.252 30.6365 13.2804C30.7073 13.3087 30.764 13.3512 30.8348 13.3937C30.8773 13.422 30.9198 13.4362 30.9623 13.4645C30.9765 13.4787 30.9765 13.4929 30.9907 13.4929C31.0473 13.5495 31.0898 13.6062 31.1323 13.6629C31.1748 13.7195 31.2173 13.762 31.2315 13.8187C31.2598 13.8754 31.2598 13.932 31.274 14.0029C31.2882 14.0737 31.3165 14.1445 31.3165 14.2295C31.3165 14.2437 31.3306 14.2579 31.3306 14.272V18.4229H31.3165Z",
    fill: "url(#paint0_linear_3460_29965)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3460_29965",
    x1: 22.9936,
    y1: 8.83203,
    x2: 22.9936,
    y2: 37.1654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--secondary-color)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--primary-color)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapRevenueIcon);
export default __webpack_public_path__ + "static/media/map-revenue-icon.a080f2302660a32911b794afe3706792.svg";
export { ForwardRef as ReactComponent };